// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import {
  Tile,
  Tag,
  StructuredListWrapper,
  StructuredListHead,
  StructuredListBody,
  StructuredListRow,
  StructuredListCell,
} from '@carbon/react';
import { usePlanDetailContext } from './PlanDetailContext';

function formatWindowDate(date: string): string {
  const d = new Date(`${date}T00:00:00`);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

function PlanExecution() {
  const { plan, planFile } = usePlanDetailContext();
  const { phases, execution_time_window } = planFile;

  return (
    <div className="sched-stack">
      {/* Header tile */}
      <Tile className="sched-section">
        <div className="sched-exec-head">
          <div>
            <h3 className="sched-section-title">Execution Phases</h3>
            <span className="sched-section-sub">
              Window: {formatWindowDate(plan.date)}, {execution_time_window.start}–
              {execution_time_window.end}
            </span>
          </div>
          <Tag type="cyan" size="md">
            {phases.length} phase{phases.length !== 1 ? 's' : ''}
          </Tag>
        </div>
      </Tile>

      {/* Phase sections */}
      {phases.map((phase, idx) => (
        <Tile key={idx} className="sched-section">
          <div className="sched-exec-head">
            <h4 className="sched-section-title">{phase.name}</h4>
            <span className="sched-section-sub">
              {phase.time_window.start}–{phase.time_window.end}
            </span>
          </div>
          <p className="sched-section-text">{phase.description}</p>

          {phase.equipment_changes.length > 0 && (
            <StructuredListWrapper isCondensed>
              <StructuredListHead>
                <StructuredListRow head>
                  <StructuredListCell head>Equipment</StructuredListCell>
                  <StructuredListCell head>Change</StructuredListCell>
                </StructuredListRow>
              </StructuredListHead>
              <StructuredListBody>
                {phase.equipment_changes.map((change, changeIdx) => (
                  <StructuredListRow key={changeIdx}>
                    <StructuredListCell>{change.equipment}</StructuredListCell>
                    <StructuredListCell>
                      {change.parameter}: {change.from_value} → {change.to_value} {change.unit}
                    </StructuredListCell>
                  </StructuredListRow>
                ))}
              </StructuredListBody>
            </StructuredListWrapper>
          )}
        </Tile>
      ))}
    </div>
  );
}

export default PlanExecution;
